import { useState, useEffect } from "react";
import {
  Facebook,
  Instagram,
  Mail,
  Phone,
  MapPin,
  CreditCard,
  Truck,
  ShieldCheck,
} from "lucide-react";
import { Link } from "react-router-dom";
import ModalAssessment from "../modalAssessment/modalAssessment";
export function Footer() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-8">
        {/* Vantagens */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 py-8 border-b border-gray-800">
          <div className="flex items-center gap-4">
            <Truck className="h-10 w-10 text-green-600" />
            <div>
              <h3 className="font-bold">Frete Grátis</h3>
              <p className="text-sm">Para compras acima de R$ 499,90</p>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <CreditCard className="h-10 w-10 text-green-600" />
            <div>
              <h3 className="font-bold">Parcele em até 12x </h3>
              <p className="text-sm">Parcele suas compras</p>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <ShieldCheck className="h-10 w-10 text-green-600" />
            <div>
              <h3 className="font-bold">Compra Segura</h3>
              <p className="text-sm">Seus dados protegidos</p>
            </div>
          </div>
        </div>

        {/* Links e Newsletter */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 py-8">
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Institucional</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/sobre"
                  className="hover:text-white transition-colors"
                >
                  Quem Somos
                </Link>
              </li>
              <li>
                <Link
                  to="/Termos-de-uso"
                  className="hover:text-white transition-colors"
                >
                  Termos e Condições
                </Link>
              </li>
              <li>
                <Link
                  to="/Politicas-de-privacidade"
                  className="hover:text-white transition-colors"
                >
                  Política de Privacidade
                </Link>
              </li>
              <li>
                <Link
                  to="/Cookies-e-politicas"
                  className="hover:text-white transition-colors"
                >
                  Política de Cookies
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold text-lg mb-4">Ajuda</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/help?section=central"
                  className="hover:text-white transition-colors"
                >
                  Central de Atendimento
                </Link>
              </li>
              <li>
                <Link
                  to="/help?section=compra"
                  className="hover:text-white transition-colors"
                >
                  Como Comprar
                </Link>
              </li>
              <li>
                <Link
                  to="/help?section=entrega"
                  className="hover:text-white transition-colors"
                >
                  Prazos e Entregas
                </Link>
              </li>
              <li>
                <Link
                  to="/help?section=troca"
                  className="hover:text-white transition-colors"
                >
                  Trocas e Devoluções
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold text-lg mb-4">Contato</h3>
            <ul className="space-y-4">
              <li className="flex items-center gap-2">
                <Phone className="h-5 w-5 text-green-600" />
                <span>(61) 8449-7981</span>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="h-5 w-5 text-green-600" />
                <span>dominusassistencia@gmail.com</span>
              </li>
              <li className="flex items-center gap-2">
                <MapPin className="h-5 w-5 text-green-600" />
                <span>Qs 118 Conjunto 06</span>
              </li>
              <li className="flex items-center gap-2">
                <MapPin className="h-5 w-5 text-green-600" />
                <span>
                  Parque da barragem setor 06 <br /> Quadra 4 conjunto B Lote 05
                </span>
              </li>
            </ul>
          </div>

          <div>
            {/* <h3 className="text-white font-bold text-lg mb-4">Newsletter</h3>
            <p className="mb-4">Cadastre-se e receba nossas novidades e promoções</p>
            <div className="flex gap-2">
              <input
                type="email"
                placeholder="Seu e-mail"
                className="bg-gray-800 border border-gray-700 rounded px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-green-600 w-full"
              />
              <button className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded transition-colors">
                Enviar
              </button>
            </div> */}

            <h3 className="text-white font-bold text-lg mt-6 mb-4">
              Redes Sociais
            </h3>
            <div className="flex gap-4">
              <Link
                to="/facebook"
                className="hover:text-white transition-colors"
              >
                <Facebook className="h-6 w-6" />
                <span className="sr-only">Facebook</span>
              </Link>
              <a
                href="https://www.instagram.com/dominustech_/"
                target="_blank"
                rel="noreferrer"
                className="hover:text-white transition-colors"
              >
                <Instagram className="h-6 w-6" />
                <span className="sr-only">Instagram</span>
              </a>
            </div>
            <div className="flex gap-2 mt-[4%]">
              <button
                onClick={() => setIsModalOpen(true)}
                className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded transition-colors"
              >
                Avalie Nosso Site
              </button>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 pt-6 pb-4 text-center">
          <p className="text-sm">
            &copy; {new Date().getFullYear()} Dominus - Todos os direitos
            reservados
          </p>
        </div>
      </div>

      <ModalAssessment
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </footer>
  );
}
